import { useRentalUnitField } from '../../../../../../../../queries/useRentalUnitField';
import { MoneyBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../../../../components/ApplicationQuestionReviewItem';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ShowIf } from '../../../../../../../components/ShowIf';

interface AnnualRentProps {
    unitGuid: string;
    required?: boolean;
    isReview?: boolean;
    showLabel?: boolean;
}

export const AnnualRent: React.FC<AnnualRentProps> = ({ unitGuid, required = false, isReview = false, showLabel = false }) => {
    const [annualRent, set_annualRent] = useRentalUnitField(
        unitGuid,
        (u) => u.rent,
        (u, v) => ({ ...u, rent: v })
    );
    const label = 'Annual Rent';
    return (
        <>
            {isReview ? (
                <>
                    <ShowIf showIf={showLabel}>
                        <ApplicationQuestionReviewItem
                            label={label}
                            value={formatCurrencyOrUndefined(annualRent)}
                            showLabel={showLabel}
                        />
                    </ShowIf>
                    <ShowIf showIf={!showLabel}>{formatCurrencyOrUndefined(annualRent)}</ShowIf>
                </>
            ) : (
                <MoneyBox
                    id={`annualRent_${unitGuid}`}
                    allowNegative={false}
                    value={annualRent}
                    onChange={(value) => set_annualRent(value)}
                    required={required}
                    label={showLabel ? label : undefined}
                />
            )}
        </>
    );
};
